let Netmask = require('netmask').Netmask;

let _ = require('lodash');

export class IpValidationUtils {
     isIpValid(ipAddress: string): boolean {
        let pattern = '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$';
        let regex = new RegExp(pattern);
        if (regex.test(ipAddress)) {
            return true;
        }
        return false;
    }

    isRangeValid(startAddress: string , endAddress: string, gatewayIP: string, prefixLength: string): boolean {
        if (!this.isIpValid(startAddress) ) {
            console.log('start address invalid');
            return false;
        }
        if (endAddress && endAddress !== '') {
            if (!this.isIpValid(endAddress) ) {
                console.log('end address invalid');
                return false;
            }
        }
        if (!this.isIpValid(gatewayIP)) {
           return false;
        }
        if (+prefixLength > 32 || +prefixLength < 1) {
            return false;
        }
        if (!this.areAllIpInRanges(startAddress, endAddress, gatewayIP, prefixLength)) {
            return false;
        }
        if (!this.isStartAddressLtEndAddress(startAddress, endAddress)) {
            return false;
        }
        return true;
    }

    isStartAddressLtEndAddress(startAddress: String , endAddress: String): boolean {
        let endAddressParts: Array<any> = endAddress.split('.');
        let startAddressParts: Array<any> = startAddress.split('.');
        let endAddressNumber = endAddressParts[0] * Math.pow(2, 24) + endAddressParts[1] * Math.pow(2, 16) +
        endAddressParts[2] * Math.pow(2, 8) + Number(endAddressParts[3]);
        let startAddressNumber = startAddressParts[0] * Math.pow(2, 24) + startAddressParts[1] * Math.pow(2, 16) +
        startAddressParts[2] * Math.pow(2, 8) + Number(startAddressParts[3]);
        if (endAddressNumber < startAddressNumber) {
            return false;
        }
        return true;
    }

    areAllIpInRanges (startAddress: String, endAddress: String, gatewayIP: String, prefixLength: String): boolean {
        try {
            let cidr: string = gatewayIP + '/' + prefixLength;
            let block = new Netmask(cidr);
            if (block.contains(startAddress) && block.contains(endAddress)) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    getNumberValue( ipAddress: String ): number {
        let ipAddressParts: Array<any> = ipAddress.split('.');
        let ipAddressValue: number = ipAddressParts[0] * Math.pow(2, 24) + ipAddressParts[1] * Math.pow(2, 16) +
        ipAddressParts[2] * Math.pow(2, 8) + Number(ipAddressParts[3]);
        return ipAddressValue;
    }

    toLong (ip) {
        let ipl = 0;
        ip.split('.').forEach(function(octet) {
            ipl <<= 8;
            ipl += parseInt(octet);
        });
        return(ipl >>> 0);
    }

    isIpInRange(ipAddress: string, startAddress: string, endAddress: string) {
        let startAddr = this.toLong(startAddress);
        let endAddr = this.toLong(endAddress);
        let ipAddr = this.toLong(ipAddress);

        if (ipAddr >= startAddr && ipAddr <= endAddr) {
            return true;
        } else {
            return false;
        }
    }

    areIpsInRange(networkId,ipAddress,secondaryAddress,network) {
        let result = true;
        let invalidIP = '';
        if( !network.data.ipScopes || network.data.ipScopes.length === 0 || network.data.ipScopes[0].networkIpRanges === null ){
            return result;
        }
        invalidIP = ipAddress;
        result = this.isIpAddressInRange(ipAddress, this.getIpRange(network));
        if (result) {
            let secondaryAddresses = (secondaryAddress) ?
                secondaryAddress.split(',') : [];
            for (let j=0; j<secondaryAddresses.length && result; ++j) {
                invalidIP = secondaryAddresses[j];
                result = this.isIpAddressInRange(secondaryAddresses[j], this.getIpRange(network));
            }
        }
        if (result) {
            return result;
        } else {
            return invalidIP;
        }
    }

    isIpAddressInRange(ipAddress, ranges) {
        let result = false;
        for (let i=0; i<ranges.length; ++i) {
            let range = ranges[i];
            if (this.isIpInRange(ipAddress, range.startAddress, range.endAddress)) {
                result = true;
                break;
            }
        }
        return result;
    }

    areIpsConflicting(networkId,ipAddress,secondaryAddress,gateway,network) {
        let result = false;
        let invalidIP;
        let secondaryAddresses = (secondaryAddress) ?
            secondaryAddress.split(',') : [];
        secondaryAddresses.push(ipAddress);

        for (let z=0; z<secondaryAddresses.length && !result; ++z) {
            for (let y=z+1; y<secondaryAddresses.length && !result; ++y) {
                invalidIP = secondaryAddresses[y];
                result = (secondaryAddresses[z] === secondaryAddresses[y]);
            }
        }
        if (result) {
            return invalidIP;
        } else {
            return result;
        }
    }


    getIpRange(network) {
        let validIPRanges = '';
        let validIpRangeArray;
        if (network.data.ipScopes && network.data.ipScopes.length !=0 && network.data.ipScopes[0].networkIpRanges != null) {
            network.data.ipScopes[0].networkIpRanges.forEach((d) => {
                validIPRanges += d.startAddress + ' - ' + d.endAddress + ', ';
            });
            validIpRangeArray = _.cloneDeep(network.data.ipScopes[0].networkIpRanges);
            validIPRanges = validIPRanges.slice(0, -2);

            /*
             * We should not add the external gateway address for System/External Networks (Internet, DirectConnect, etc)
             * for internal network participation.
             * @See Ticket #1950978
             */
            if(!network.data.ownedBySystem) {
                let gatewayAddress = network.data.ipScopes[0].gateway;
                let networkRange = {
                    'startAddress': gatewayAddress,
                    'endAddress': gatewayAddress
                }
                validIpRangeArray.push(networkRange);
            }
        }
        return validIpRangeArray;
    }

    areRangesOverlapping(ipRangeOne, ipRangeTwo) {
        if (this.isIpInRange(ipRangeOne.startAddress, ipRangeTwo.startAddress, ipRangeTwo.endAddress)
        || this.isIpInRange(ipRangeOne.endAddress, ipRangeTwo.startAddress, ipRangeTwo.endAddress)
        || this.isIpInRange(ipRangeTwo.startAddress, ipRangeOne.startAddress, ipRangeOne.endAddress)
        || this.isIpInRange(ipRangeTwo.endAddress, ipRangeOne.startAddress, ipRangeOne.endAddress)) {
            return true;
        } else {
            return false;
        }
    }

    // Use this when gateway IP is not provided
    validateIpRangeUsingPrefix (startAddress: String, endAddress: String, prefixLength: String): boolean {
        if (!this.isStartAddressLtEndAddress(startAddress, endAddress)) {
            return false;
        }
        try {
            let cidrStart: string = startAddress + '/' + prefixLength;
            let blockStart = new Netmask(cidrStart);

            let cidrEnd: string = endAddress + '/' + prefixLength;
            let blockEnd = new Netmask(cidrEnd);

            if (blockStart['base'] === blockEnd['base']) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }


    isPrefixValid(prefixLength: string): boolean {
        let pattern = '^([0-9]|3[0-2]|[0-2][0-9])$';
        let regex = new RegExp(pattern);
        if (regex.test(prefixLength)) {
            return true;
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/common/validations/ip-validation-utils.ts